export default __webpack_public_path__ + "static/media/insta1.787ac7bf.svg";